(function ($) {
	"use strict";
	let blockwheelsVideoBox = {
		initAll: function () {

			const elementList = document.querySelectorAll('.wp-block-blockwheels-video-box');

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Video Box
			[...elementList].forEach((videoBox) => {
				let videoBoxId 	= $(videoBox).data('id'),
					type 		= $(videoBox).data("type");
				$(videoBox).on("click", () => {
					$(videoBox).addClass("video-overlay-disable");
					let $video 	= $(videoBox).find("iframe, video"),
						src 	= $video.attr("src");
					setTimeout(() => {
						if ("self" === type) {
							$(videoBox).find(".blockwheels-video-box-overlay").remove();
							$($video)
								.get(0)
								.play();
						} else {
							$video.attr("src", src.replace("autoplay=0", "autoplay=1"));
						}
					}, 300);
				});
			});
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsVideoBox.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsVideoBox.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsVideoBox.init();
	}
})(jQuery);